import Config from '../config';

export const CONTENT_PROVIDER_AUTH = {
    IDP: Config.cloudpass.IDP_SHORTCODE
}

export const DEFAULT_CONTENT_PROVIDER_AUTH = {
    countryCode: 'CL'
}